module.exports = __webpack_public_path__ + "img/tuzi.445a45ec.png";